import React, { FC } from 'react';
import { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';

export const IconPlus: FC<PropsWithClassProps<'iconPlus'>> = ({ classProps }) => {
  return (
    <svg
      className={classProps?.iconPlus}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="3" y1="8.5" x2="15" y2="8.5" stroke="black" />
      <line x1="9.5" y1="3" x2="9.5" y2="15" stroke="black" />
    </svg>
  );
};
